import styled from "styled-components";
import { ThemeType } from "../../../types/Theme";

const transitionTime = "1s";
const SkeletonAssinaturaContainer = styled.div<{ theme: ThemeType }>`
  padding: 3.2rem 6.4rem 8rem;
  width: 100%;
  display: grid;
  grid-template-columns: 558px 1px 1fr;
  gap: 4rem;

  @media (max-width: 1100px) {
    grid-template-columns: 1fr;
    padding: 3.2rem;
  }

  .col-esquerda,
  .col-direita {
    display: flex;
    flex-direction: column;
    gap: 1.6rem;
  }

  .col-divisor {
    background-color: ${({ theme }) => theme.colors.elements};
    width: 1px;

    @media (max-width: 1100px) {
      display: none;
    }
  }

  .bloco {
    height: 3.3rem;
    border-radius: 3.2rem;
    background: ${({ theme }) => theme.colors.white};
    animation-delay: calc(var(--i) * 0.05s);
    animation: pulsate ${transitionTime} ease-out infinite alternate;
  }

  .bloco-alto {
    height: 7rem;
    border-radius: 1.6rem;
    background: ${({ theme }) => theme.colors.white};
    animation: pulsate ${transitionTime} ease-out infinite alternate;
  }

  .bloco-titulo {
    height: 2rem;
    width: 20rem;
    border-radius: 0.4rem;
    background: ${({ theme }) => theme.colors.white};
    animation: pulsate ${transitionTime} ease-out infinite alternate;
  }
`;

export { SkeletonAssinaturaContainer };
